import styled from 'styled-components'

export function makeCareguideCorp (element) {
  return styled(element)`
    a {
      text-decoration: none;
    }
  `
}

export default makeCareguideCorp
